import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=c1147be2&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=c1147be2&prod&lang=css"
import style1 from "./coupon.vue?vue&type=style&index=1&id=c1147be2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1147be2",
  null
  
)

export default component.exports